
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from 'src/app/features/medical-record/model/question.model';

@Component({
  selector: 'app-chips-with-category',
  templateUrl: './chips-with-category.component.html',
  styleUrls: ['./chips-with-category.component.scss']
})
export class ChipsWithCategoryComponent {

  @Input() title: string = '';
  @Input() width: string = '';
  @Input() height: string = '';
  @Input() isAddingOrEditing: string = 'adding';
  @Input() arrayItems: Array<Question> = [];
  @Input() arrayTitles: Array<Question> = [];

  @Output() addOrEditButton = new EventEmitter();

  keys = Object.keys;

  constructor() {

  }

  executeFunction() {

    this.addOrEditButton.emit();
  }

  applyDesign() {

    return { width: this.width, display: 'grid' };
  }

  applyChipsDesign() {

    return { 'min-height': this.height, width: this.width };
  }
}
